/**
 * This selector uses keys to determine if an item is selected or not.
 * The default getKey function will assume the item is an array [ key, value ]
 * and return the key. 
 * <code>
 * this.selector = new KeySelector( { 
 *    useMeta : true,
 *    getSelected : ( ) => { return this.state.selected },
 *    setSelected : ( selected, cb ) => { this.setState( { selected }, cb ) }
 *  } )
 * </code>
 */
export default class KeySelector {
  constructor({
    setSelected,
    getSelected,
    getKey,
    allowSelect,
    useMeta
  }) {
    this.getSelected = getSelected;
    this.setSelected = setSelected;
    this.allowSelect = allowSelect;
    this.useMeta = useMeta;
    this.getKey = getKey || defaultGetKey;
  }
  isSelected = item => {
    const sKey = this.getSelected();
    return sKey === this.getKey(item);
  };
  onSelect = event => {
    const item = event.value;
    const meta = event.sourceEvent && event.sourceEvent.metaKey;
    const selected = this.isSelected(item);
    const cb = event.onSelect ? () => {
      event.onSelect(item);
    } : null;
    if (this.useMeta && meta && selected) {
      // Handle emptying the selection
      if (this.allowSelect == null || this.allowSelect(null) !== false) {
        this.setSelected(null, cb);
      }
      return;
    }
    if (selected) {
      // already selected
      return;
    }
    const nKey = this.getKey(item);
    if (this.allowSelect == null || this.allowSelect(item) !== false) {
      this.setSelected(nKey, cb);
    }
  };
}
function defaultGetKey(item) {
  return item[0];
}